
import React from 'react';
import { Helmet } from 'react-helmet-async';
import GameHero from '../components/pokemon-clicker/GameHero';
import GameDescription from '../components/pokemon-clicker/GameDescription';
import GameFeatures from '../components/pokemon-clicker/GameFeatures';
import GameGuide from '../components/pokemon-clicker/GameGuide';
import GameFAQ from '../components/pokemon-clicker/GameFAQ';

const PokemonClicker = () => {
  return (
    <>
      <Helmet>
        <title>Pokemon Clicker - Free Online Pokemon Incremental Game</title>
        <meta 
          name="description" 
          content="Play Pokemon Clicker free online! Catch, train and evolve Pokemon in this addictive incremental clicker game. No download required, play in your browser now!" 
        />
        <meta name="keywords" content="Pokemon Clicker, free online game, pokemon game, clicker game, incremental game, catch pokemon" />
        <link rel="canonical" href="https://pokedle.com/pokemon-clicker" />
      </Helmet>

      <div className="bg-gradient-to-b from-blue-900 via-blue-800 to-indigo-900 text-white min-h-screen">
        <GameHero />
        
        <div className="container mx-auto px-4 py-8">
          {/* Game iframe container */}
          <div className="my-10" id="play-now">
            <h2 className="text-3xl font-bold mb-6 text-center text-yellow-300 drop-shadow-lg">Play Pokemon Clicker</h2>
            <div className="game-wrapper bg-black rounded-xl shadow-2xl overflow-hidden border-4 border-yellow-400">
              <iframe 
                src="https://scratch.mit.edu/projects/116421566/embed" 
                style={{ width: '100%', height: '100%' }} 
                frameBorder="0" 
                allow="gamepad *;"
                title="Pokemon Clicker Game"
              ></iframe>
            </div>
          </div>
          
          <GameDescription />
          <GameFeatures />
          <GameGuide />
          <GameFAQ />
        </div>
      </div>
    </>
  );
};

export default PokemonClicker;
